// Components
import { StepIntegrationXComponent } from './step-integration-x.component';

// Models
import { MediaUploadFlowStep } from '../../../../../../shared/_model/flow.model';

export const STEP_INTEGRATION_X = {
  stepIdentifier: 'mediaUploadFlowStepIntegrationX',
  identifier: 'x',
  component: StepIntegrationXComponent,
  name: 'X',
  title: 'X Configuration',
  header: true,
  headerDistinctive: true,
  displayInFlowProgressBar: true,
  canNavigateBack: false,
  subStep: true,
} as MediaUploadFlowStep;
